import PrebuiltBetBuilderClassicImpl from './prebuilt-bet-builder-classic.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import EventCardsTypes from 'modules/event-cards/types.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetBuilderClassic view that renders prebuilt bet builder card with the classic layout.
 *
 * @class PrebuiltBetBuilderClassic
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltBetBuilderClassic prop types.
 *
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {string} [imgUrl] - Optional card background image.
 * @property {Mojito.Modules.EventCards.types.COLOR_MODES} [colorMode] - Card presentation mode.
 *
 * @memberof Mojito.Modules.PrebuiltBetBuilderClassic
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
    imgUrl: PropTypes.string,
    colorMode: PropTypes.oneOf(Object.values(EventCardsTypes.COLOR_MODES)),
};

export default UIView('PrebuiltBetBuilderClassic', PrebuiltBetBuilderClassicImpl, propTypes);
